import Box from "@material-ui/core/esm/Box";
import { nanoid } from 'nanoid';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { FormElement, AutocompleteAsync } from 'components/Form';
import InfoBox from 'components/InfoBox/InfoBox';
import useTerminateInactiveTag from 'hooks/tags/useTerminateInactiveTag';
const idSuffix = nanoid();
export default function ChooseTag() {
  const {
    t
  } = useTranslation();
  const {
    tagNumber
  } = useParams();
  const {
    tag,
    setTag,
    inactiveObes,
    obesLoading,
    isObeBeingMoved
  } = useTerminateInactiveTag();
  useEffect(() => {
    setTag(tagNumber);
  }, [tagNumber, setTag]);
  const onChange = async (_event, newTag) => {
    setTag(newTag.obeNumber);
  };
  const autocompleteInputId = `choose_inactive_tag_autocomplete_${idSuffix}`;
  return /*#__PURE__*/React.createElement(Box, {
    mt: 2
  }, /*#__PURE__*/React.createElement(FormElement, {
    title: t('terminate_inactive_tag.choose_tag'),
    childId: autocompleteInputId
  }, /*#__PURE__*/React.createElement(AutocompleteAsync, {
    placeholder: t('tag.tag_number'),
    options: inactiveObes ?? [],
    onChange: onChange,
    optionLabel: "obeNumber",
    isLoading: obesLoading,
    value: inactiveObes?.find(obe => obe.obeNumber === tag) ?? null,
    inputId: autocompleteInputId
  }), isObeBeingMoved && /*#__PURE__*/React.createElement(InfoBox, {
    warning: true
  }, t('error.is_being_moved'))));
}